import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { TASK_FORM_FIELDS } from '../../../helpers/form';
import { WBFlex, WBTextFieldV2, WBTypography } from '@admiin-com/ds-web';
import React from 'react';
import { useCurrentUser } from '../../../hooks/useCurrentUser/useCurrentUser';
import { InvoiceStatus } from '@admiin-com/ds-graphql';

export const InvoiceEmailMessage = () => {
  const { control, setValue } = useFormContext();
  const to = useWatch({ name: 'to', control });

  console.log('tototo: ', to);

  const user = useCurrentUser();
  const toFirstName = to?.firstName ?? to?.contact?.firstName ?? to?.name ?? '';
  const userFirstName = user?.firstName ?? '';

  const invoiceStatus = useWatch({ name: 'invoiceStatus', control });
  const invoiceType =
    invoiceStatus === InvoiceStatus.INVOICE ? 'invoice' : 'quote';

  const emailMessage = React.useMemo(() => {
    return `Hi ${toFirstName},
Please find your latest ${invoiceType} attached, let us know if you have any questions.
Thank you for your business!
Kind regards,
${userFirstName}`;
  }, [invoiceType, userFirstName, toFirstName]);

  const inputs = React.useMemo(
    () => ({
      emailMessage: {
        ...TASK_FORM_FIELDS.emailMessage,
        defaultValue: emailMessage,
      },
    }),
    [emailMessage]
  );

  React.useEffect(() => {
    setValue('emailMessage', emailMessage);
  }, [emailMessage, setValue]);

  return (
    <WBFlex flexDirection="column" flex={1}>
      <WBTypography fontWeight={'bold'}>
        {inputs.emailMessage.label}
      </WBTypography>
      <Controller
        control={control}
        defaultValue={inputs.emailMessage.defaultValue}
        name={inputs.emailMessage.name}
        render={({ field }) => (
          <WBTextFieldV2
            {...field}
            multiline
            placeholder={inputs.emailMessage.placeholder}
            name={inputs.emailMessage.name}
            type={inputs.emailMessage.type}
          />
        )}
      />
    </WBFlex>
  );
};
